const Route = Object.freeze({
  APIKEYVALIDATION: '/access/key/verify/',
  DEVICES: '/devices/devices/',
  DEVICEFORPORTAL: '/devices/devices_for_portal/',
  REGISTERDEVICEVERIFICATION: '/push/device/registerdevice/verify/',
  REGISTERDEVICETEST: '/push/device/registerdevice/test/',
  REGISTERDEVICE: '/push/device/registerdevice/',
  NOTIFICATION_SUBSCRIPTION: '/push/devices/',
  NOTIFICATION: '/chl/notifications/',
  GRPWALLPAPER: '/resource/background/wallpaper/',
  MARK_NOTIFICATION_READ: '/push/mark/read/',
  LOCATION: '/access/location/',
  ORGANIZATION: '/configuration/org/',
  PMSCUSTOMER: '/pms/customer/',
  LANGUAGE: '/apps/languages/',
  PATIENT: '/hospital/patient/',
  PASSWORD_AUTH: '/user/login/app/',
  REGISTER_ROOM: '/hospital/room/',
  PROFILESEGMENT: '/hospital/profile_segment/',   
  PROFILEFIELD: '/hospital/profile_field/',
  PROFILESUBFIELD: '/hospital/profile_sub_field/',
  HL7_RECEIVER: '/hl7/httpreceiver/',
  THIRDPARTYSERVICE: '/access/thirdparty/services/',
  CALLTHIRDPARTYSERVICE: '/access/thirdparty/services/request/',
  LATESTNEWS: '/access/latestnews/',
  WELCOMENOTE: '/access/welcomenote/',
  ACCREDITATIONS: '/access/accreditation/',
  SLIDERTIMER: '/resource/background/wallpaper/config/',
  PROFILECATEGORIES: '/profile/categories/',
  PROFILE: '/profile/organization/configured/',
  ORGANIZATIONCHANNEL: '/channel/organization/group/configured/',
  ORGANIZATIONGROUPCHANNEL: '/channel/organizationgroupchannels/',
  ORGANIZATIONTEMPLATE: '/layout/organizationtemplate/',
  ORGANIZATIONGROUPTEMPLATE: '/layout/organizationgrouptemplate/',
  ORGANIZATIONTHEME: '/layout/organizationtheme/',
  ORGANIZATIONGROUPTHEME: '/layout/organizationgrouptheme/',
  LIVE_SCREEN: '/live/image/',
  proxy_server: '/push/device/proxyserver/verify/',
  TRACKINGSERVICE: '/tracking/track/',
  ORGANIZATIONGROUP: '/hospital/group/',
  S3PRESIGNEDURL: '/resource/s3/presigned/url/',
  DEVICES_LIST: '/user/organization/devices/',
  ORGANIZATION_IDENTITY: '/user/organization/identity/',
});

export default Route;
